import React from 'react';
import parseHTML from 'html-react-parser';
import AvailableServices from "./bper-available-services";


export default function Times({ translations, subsidiary, type, cashLight, showServiceInfo, setShowServiceInfo }) {

    const currentDay = new Date().getDay();
    const currentTime = new Date();
    const currentDate = new Date().toISOString().split('T')[0]; //es.2020-11-25
    const time_mattino = subsidiary.timetables
        ?
        currentDay === 1
            ? subsidiary.timetables.openMondayMorning
            : currentDay === 2
                ? subsidiary.timetables.openTuesdayMorning
                : currentDay === 3
                    ? subsidiary.timetables.openWednesdayMorning
                    : currentDay === 4
                        ? subsidiary.timetables.openThursdayMorning
                        : currentDay === 5
                            ? subsidiary.timetables.openFridayMorning
                            : currentDay === 6
                                ? subsidiary.timetables.openSaturdayMorning
                                : subsidiary.timetables.openSundayMorning //currentDay=7
        : undefined;
    const time_pomeriggio = subsidiary.timetables
        ?
        currentDay === 1
            ? subsidiary.timetables.openMondayAfternoon
            : currentDay === 2
                ? subsidiary.timetables.openTuesdayAfternoon
                : currentDay === 3
                    ? subsidiary.timetables.openWednesdayAfternoon
                    : currentDay === 4
                        ? subsidiary.timetables.openThursdayAfternoon
                        : currentDay === 5
                            ? subsidiary.timetables.openFridayAfternoon
                            : currentDay === 6
                                ? subsidiary.timetables.openSaturdayAfternoon
                                : subsidiary.timetables.openSundayAfternoon //currentDay=7
        : undefined;

        
    const time_start_mattino =
        time_mattino && time_mattino !== 'chiuso'
            ? new Date(
                currentDate.split("-")[0],parseInt(currentDate.split("-")[1])-1,currentDate.split("-")[2],
                time_mattino.split(' ')[0].split(".")[0],time_mattino.split(' ')[0].split(".")[1]
            )
            : undefined;
    const time_end_mattino =
        time_mattino && time_mattino.toLowerCase() !== 'chiuso'
            ? new Date(
                currentDate.split("-")[0],parseInt(currentDate.split("-")[1])-1,currentDate.split("-")[2],
                time_mattino.split(' ')[1].split(".")[0],time_mattino.split(' ')[1].split(".")[1]
            )
            : undefined;
    const time_start_pomeriggio =
        time_pomeriggio && time_pomeriggio.toLowerCase() !== 'chiuso'
            ? new Date(
                currentDate.split("-")[0],parseInt(currentDate.split("-")[1])-1,currentDate.split("-")[2],
                time_pomeriggio.split(' ')[0].split(".")[0],time_pomeriggio.split(' ')[0].split(".")[1]
            )
            : undefined;

    const time_end_pomeriggio =
        time_pomeriggio && time_pomeriggio.toLowerCase() !== 'chiuso'
            ? new Date(
                currentDate.split("-")[0],parseInt(currentDate.split("-")[1])-1,currentDate.split("-")[2],
                time_pomeriggio.split(' ')[1].split(".")[0],time_pomeriggio.split(' ')[1].split(".")[1]
            )
            : undefined;

    let stringOpenTime = '';
    if (currentTime < time_start_mattino) {
        stringOpenTime =
            translations.NowCloseOpenAt +
            time_mattino.split(' ')[0];
    } else {
        if (currentTime < time_end_mattino) {
            stringOpenTime =
                translations.OpenCloseAt +
                time_mattino.split(' ')[1];
        } else {
            if (currentTime < time_start_pomeriggio) {
                stringOpenTime =
                    translations.NowCloseOpenAt +
                    time_pomeriggio.split(' ')[0];
            } else {
                if (currentTime < time_end_pomeriggio) {
                    stringOpenTime =
                        translations.OpenCloseAt +
                        time_pomeriggio.split(' ')[1];
                } else {
                    stringOpenTime = translations.NowClose;
                }
            }
        }
    }

    /*const sameLunediVenerdi=subsidiary.timetables &&
        subsidiary.timetables.openMondayMorning === subsidiary.timetables.openTuesdayMorning &&
        subsidiary.timetables.openMondayMorning === subsidiary.timetables.openWednesdayMorning &&
        subsidiary.timetables.openMondayMorning === subsidiary.timetables.openThursdayMorning &&
        subsidiary.timetables.openMondayMorning === subsidiary.timetables.openFridayMorning &&
        subsidiary.timetables.openMondayAfternoon === subsidiary.timetables.openTuesdayAfternoon &&
        subsidiary.timetables.openMondayAfternoon === subsidiary.timetables.openWednesdayAfternoon &&
        subsidiary.timetables.openMondayAfternoon === subsidiary.timetables.openThursdayAfternoon &&
        subsidiary.timetables.openMondayAfternoon === subsidiary.timetables.openFridayAfternoon;*/

    const sameSabatoDomenicaChiuso = subsidiary.timetables &&
        subsidiary.timetables.openSaturdayMorning.toLowerCase() === 'chiuso' &&
        subsidiary.timetables.openSundayMorning.toLowerCase() === 'chiuso' &&
        subsidiary.timetables.openSaturdayAfternoon.toLowerCase() === 'chiuso' &&
        subsidiary.timetables.openSundayAfternoon.toLowerCase() === 'chiuso';

    const dashHouser = (str) => {
        return str.replace(" ", " - ");
    }

    const el = subsidiary;

    return (
        <div className="times">
            {(subsidiary.subsdiaryType != "CP")  && (
            <div className="times-content">
                {type && type !== "closest" &&
                    <h2 className='title | font-heading-s font-heading-desktop-m fw-400'>{translations.times}</h2>
                }
                <p className='status | font-body-l fw-300'>{parseHTML(stringOpenTime)}</p>
                {
                    cashLight &&
                    <span className="small cashlight | fw-300" style={{ display: "block" }}>
                        ({subsidiary.cashLight})
                    </span>
                }
                {type !== "closest" && el.timetables &&
                    <>
                        <div className="row horizontal orari-wrapper">

                            <div className="orari-content | font-body-l fw-300">
                                <b className="orari-content-th">&nbsp;</b>
                                <ul className="orari-content-th">
                                    <li className="orari-content-th"><b>{translations.Morning}</b></li>
                                    <li className="orari-content-th"><b>{translations.Afternoon}</b></li>
                                </ul>
                                {
                            /*sameLunediVenerdi  &&
                                <>

                                    <b>{translations.MondayFriday}</b>
                                    <ul>
                                        <li>
                                            {
                                                el.timetables.openMondayMorning.split(
                                                    ' '
                                                )[0]
                                            }
												-
												{
                                                el.timetables.openMondayMorning.split(
                                                    ' '
                                                )[1]
                                            }
                                        </li>
                                        <li>
                                            {
                                                el.timetables.openMondayAfternoon.split(
                                                    ' '
                                                )[0]
                                            }
												-
												{
                                                el.timetables.openMondayAfternoon.split(
                                                    ' '
                                                )[1]
                                            }
                                        </li>
                                    </ul>
                                </>
                                */}
                                <>
                                    <b>{translations.Monday}</b>
                                    <ul>
                                        {type !== "detail" && el.timetables.openMondayMorning.toLowerCase().trim() ===
                                            'chiuso' &&
                                            el.timetables.openMondayAfternoon.toLowerCase().trim() ===
                                            'chiuso' ? (
                                                <li>{translations.close}</li>
                                            ) : (
                                                <>
                                                    {el.timetables.openMondayMorning.toLowerCase() !==
                                                        'chiuso' ? (
                                                            <li>
                                                                {
                                                                    el.timetables.openMondayMorning.toLowerCase() === "chiuso"
                                                                        ? <>
                                                                            {translations.close}
                                                                        </>
                                                                        :
                                                                        <>
                                                                            {
                                                                                el.timetables.openMondayMorning.split(' ')[0]
                                                                            }
															                -
                                                                            {
                                                                                el.timetables.openMondayMorning.split(' ')[1]
                                                                            }
                                                                        </>
                                                                }
                                                            </li>
                                                        ) : (
                                                            <li>
                                                                {translations.close}
                                                            </li>
                                                        )}
                                                    {el.timetables.openMondayAfternoon.toLowerCase() !==
                                                        'chiuso' ? (
                                                            <li>
                                                                {
                                                                    el.timetables.openMondayAfternoon.toLowerCase() === "chiuso"
                                                                        ? <>
                                                                            {translations.close}
                                                                        </>
                                                                        :
                                                                        <>
                                                                            {
                                                                                el.timetables.openMondayAfternoon.split(
                                                                                    ' '
                                                                                )[0]
                                                                            }
															-
                                                                            {
                                                                                el.timetables.openMondayAfternoon.split(
                                                                                    ' '
                                                                                )[1]
                                                                            }
                                                                        </>
                                                                }
                                                            </li>
                                                        ) : (
                                                            <li>
                                                                {translations.close}
                                                            </li>
                                                        )}
                                                </>
                                            )}
                                    </ul>

                                    <b>{translations.Tuesday}</b>
                                    <ul>
                                        {type !== "detail" && el.timetables.openTuesdayMorning.toLowerCase().trim() ===
                                            'chiuso' &&
                                            el.timetables.openTuesdayAfternoon.toLowerCase().trim() ===
                                            'chiuso' ? (
                                                <li>{translations.close}</li>
                                            ) : (
                                                <>
                                                    {el.timetables.openTuesdayMorning ? (
                                                        <li>
                                                            {
                                                                el.timetables.openTuesdayMorning.toLowerCase() === "chiuso"
                                                                    ? <>
                                                                        {translations.close}
                                                                    </>
                                                                    :
                                                                    <>
                                                                        {
                                                                            el.timetables.openTuesdayMorning.split(
                                                                                ' '
                                                                            )[0]
                                                                        }
															-
                                                                        {
                                                                            el.timetables.openTuesdayMorning.split(
                                                                                ' '
                                                                            )[1]
                                                                        }
                                                                    </>
                                                            }
                                                        </li>
                                                    ) : (
                                                            <li>
                                                                {translations.close}
                                                            </li>
                                                        )}
                                                    {el.timetables.openTuesdayAfternoon ? (
                                                        <li>
                                                            {
                                                                el.timetables.openTuesdayAfternoon.toLowerCase() === "chiuso"
                                                                    ? <>
                                                                        {translations.close}
                                                                    </>
                                                                    :
                                                                    <>
                                                                        {
                                                                            el.timetables.openTuesdayAfternoon.split(
                                                                                ' '
                                                                            )[0]
                                                                        }
															-
                                                                        {
                                                                            el.timetables.openTuesdayAfternoon.split(
                                                                                ' '
                                                                            )[1]
                                                                        }
                                                                    </>
                                                            }
                                                        </li>
                                                    ) : (
                                                            <li>
                                                                {translations.close}
                                                            </li>
                                                        )}
                                                </>
                                            )}
                                    </ul>
                                    <b>{translations.Wednesday}</b>
                                    <ul>
                                        {type !== "detail" && el.timetables.openWednesdayMorning.toLowerCase().trim() ===
                                            'chiuso' &&
                                            el.timetables.openWednesdayAfternoon.toLowerCase().trim() ===
                                            'chiuso' ? (
                                                <li>{translations.close}</li>
                                            ) : (
                                                <>
                                                    {el.timetables.openWednesdayMorning ? (
                                                        <li>
                                                            {
                                                                el.timetables.openWednesdayMorning.toLowerCase() === "chiuso"
                                                                    ? <>
                                                                        {translations.close}
                                                                    </>
                                                                    :
                                                                    <>
                                                                        {
                                                                            el.timetables.openWednesdayMorning.split(
                                                                                ' '
                                                                            )[0]
                                                                        }
															-
                                                                        {
                                                                            el.timetables.openWednesdayMorning.split(
                                                                                ' '
                                                                            )[1]
                                                                        }
                                                                    </>
                                                            }
                                                        </li>
                                                    ) : (
                                                            <li>
                                                                {translations.close}
                                                            </li>
                                                        )}
                                                    {el.timetables.openWednesdayAfternoon ? (
                                                        <li>
                                                            {
                                                                el.timetables.openWednesdayAfternoon.toLowerCase() === "chiuso"
                                                                    ? <>
                                                                        {translations.close}
                                                                    </>
                                                                    :
                                                                    <>
                                                                        {
                                                                            el.timetables.openWednesdayAfternoon.split(
                                                                                ' '
                                                                            )[0]
                                                                        }
															-
                                                                        {
                                                                            el.timetables.openWednesdayAfternoon.split(
                                                                                ' '
                                                                            )[1]
                                                                        }
                                                                    </>
                                                            }
                                                        </li>
                                                    ) : (
                                                            <li>
                                                                {translations.close}
                                                            </li>
                                                        )}
                                                </>
                                            )}
                                    </ul>
                                    <b>{translations.Thursday}</b>
                                    <ul>
                                        {type !== "detail" && el.timetables.openThursdayMorning.toLowerCase().trim() ===
                                            'chiuso' &&
                                            el.timetables.openThursdayAfternoon.toLowerCase().trim() ===
                                            'chiuso' ? (
                                                <li>{translations.close}</li>
                                            ) : (
                                                <>
                                                    {el.timetables.openThursdayMorning ? (
                                                        <li>
                                                            {
                                                                el.timetables.openThursdayMorning.toLowerCase() === "chiuso"
                                                                    ? <>
                                                                        {translations.close}
                                                                    </>
                                                                    :
                                                                    <>
                                                                        {
                                                                            el.timetables.openThursdayMorning.split(
                                                                                ' '
                                                                            )[0]
                                                                        }
															-
                                                                        {
                                                                            el.timetables.openThursdayMorning.split(
                                                                                ' '
                                                                            )[1]
                                                                        }
                                                                    </>
                                                            }
                                                        </li>
                                                    ) : (
                                                            <li>
                                                                {translations.close}
                                                            </li>
                                                        )}
                                                    {el.timetables.openThursdayAfternoon ? (
                                                        <li>
                                                            {
                                                                el.timetables.openThursdayAfternoon.toLowerCase() === "chiuso"
                                                                    ? <>
                                                                        {translations.close}
                                                                    </>
                                                                    :
                                                                    <>
                                                                        {
                                                                            el.timetables.openThursdayAfternoon.split(
                                                                                ' '
                                                                            )[0]
                                                                        }
															-
                                                                        {
                                                                            el.timetables.openThursdayAfternoon.split(
                                                                                ' '
                                                                            )[1]
                                                                        }
                                                                    </>
                                                            }
                                                        </li>
                                                    ) : (
                                                            <li>
                                                                {translations.close}
                                                            </li>
                                                        )}
                                                </>
                                            )}
                                    </ul>
                                    <b>{translations.Friday}</b>
                                    <ul>
                                        {type !== "detail" && el.timetables.openFridayMorning.toLowerCase().trim() ===
                                            'chiuso' &&
                                            el.timetables.openFridayAfternoon.toLowerCase().trim() ===
                                            'chiuso' ? (
                                                <li>{translations.close}</li>
                                            ) : (
                                                <>
                                                    {el.timetables.openFridayMorning ? (
                                                        <li>
                                                            {
                                                                el.timetables.openFridayMorning.toLowerCase() === "chiuso"
                                                                    ? <>
                                                                        {translations.close}
                                                                    </>
                                                                    :
                                                                    <>
                                                                        {
                                                                            el.timetables.openFridayMorning.split(
                                                                                ' '
                                                                            )[0]
                                                                        }
															-
                                                                        {
                                                                            el.timetables.openFridayMorning.split(
                                                                                ' '
                                                                            )[1]
                                                                        }
                                                                    </>
                                                            }
                                                        </li>
                                                    ) : (
                                                            <li>
                                                                {translations.close}
                                                            </li>
                                                        )}
                                                    {el.timetables.openFridayAfternoon ? (
                                                        <li>
                                                            {
                                                                el.timetables.openFridayAfternoon.toLowerCase() === "chiuso"
                                                                    ? <>
                                                                        {translations.close}
                                                                    </>
                                                                    :
                                                                    <>
                                                                        {
                                                                            el.timetables.openFridayAfternoon.split(
                                                                                ' '
                                                                            )[0]
                                                                        }
															-
                                                                        {
                                                                            el.timetables.openFridayAfternoon.split(
                                                                                ' '
                                                                            )[1]
                                                                        }
                                                                    </>
                                                            }
                                                        </li>
                                                    ) : (
                                                            <li>
                                                                {translations.close}
                                                            </li>
                                                        )}
                                                </>
                                            )}
                                    </ul>
                                </>

                                {sameSabatoDomenicaChiuso ? (
                                    <>
                                        {type === "closest" ?
                                            <>
                                                <b>{translations.SaturdaySunday}</b>
                                                <ul>
                                                    <li>{translations.close}</li>
                                                    <li>{translations.close}</li>
                                                </ul>
                                            </>
                                            : <>
                                                <b>{translations.SaturdaySunday}</b>
                                                <ul>
                                                    <li>{translations.close}</li>
                                                    <li>{translations.close}</li>
                                                </ul>
                                            </>
                                        }
                                    </>

                                ) : (
                                        <>
                                            <b>{translations.Saturday}</b>
                                            <ul>
                                                {el.timetables.openSaturdayMorning.toLowerCase().trim() ===
                                                    'chiuso' &&
                                                    el.timetables.openSaturdayAfternoon.toLowerCase().trim() ===
                                                    'chiuso' ? (
                                                        <li>{translations.close}</li>
                                                    ) : (
                                                        <>
                                                            {el.timetables.openSaturdayMorning ? (
                                                                <li>

                                                                    {
                                                                        el.timetables.openSaturdayMorning.toLowerCase() === "chiuso"
                                                                            ? <>
                                                                                {translations.close}
                                                                            </>
                                                                            :
                                                                            <>
                                                                                {
                                                                                    el.timetables.openSaturdayMorning.split(
                                                                                        ' '
                                                                                    )[0]
                                                                                }
															-
                                                                                {
                                                                                    el.timetables.openSaturdayMorning.split(
                                                                                        ' '
                                                                                    )[1]
                                                                                }
                                                                            </>
                                                                    }
                                                                </li>
                                                            ) : (
                                                                    <li>
                                                                        {translations.close}
                                                                    </li>
                                                                )}
                                                            {el.timetables.openSaturdayAfternoon ? (
                                                                <li>
                                                                    {
                                                                        el.timetables.openSaturdayAfternoon.toLowerCase() === "chiuso"
                                                                            ? <>
                                                                                {translations.close}
                                                                            </>
                                                                            :
                                                                            <>
                                                                                {
                                                                                    el.timetables.openSaturdayAfternoon.split(
                                                                                        ' '
                                                                                    )[0]
                                                                                }
															-
                                                                                {
                                                                                    el.timetables.openSaturdayAfternoon.split(
                                                                                        ' '
                                                                                    )[1]
                                                                                }
                                                                            </>
                                                                    }
                                                                </li>
                                                            ) : (
                                                                    <li>
                                                                        {translations.close}
                                                                    </li>
                                                                )}
                                                        </>
                                                    )}
                                            </ul>
                                            <b>{translations.Sunday}</b>
                                            <ul>
                                                {el.timetables.openSundayMorning.toLowerCase().trim() ===
                                                    'chiuso' &&
                                                    el.timetables.openSundayAfternoon.toLowerCase().trim() ===
                                                    'chiuso' ? (
                                                        <li>{translations.close}</li>
                                                    ) : (
                                                        <>
                                                            {el.timetables.openSundayMorning ? (
                                                                <li>
                                                                    {
                                                                        el.timetables.openSundayMorning.toLowerCase() === "chiuso"
                                                                            ? <>
                                                                                {translations.close}
                                                                            </>
                                                                            :
                                                                            <>
                                                                                {
                                                                                    el.timetables.openSundayMorning.split(
                                                                                        ' '
                                                                                    )[0]
                                                                                }
															-
                                                                                {
                                                                                    el.timetables.openSundayMorning.split(
                                                                                        ' '
                                                                                    )[1]
                                                                                }
                                                                            </>
                                                                    }
                                                                </li>
                                                            ) : (
                                                                    <li>
                                                                        {translations.close}
                                                                    </li>
                                                                )}
                                                            {el.timetables.openSundayAfternoon ? (
                                                                <li>
                                                                    {
                                                                        el.timetables.openSundayAfternoon.toLowerCase() === "chiuso"
                                                                            ? <>
                                                                                {translations.close}
                                                                            </>
                                                                            :
                                                                            <>
                                                                                {
                                                                                    el.timetables.openSundayAfternoon.split(
                                                                                        ' '
                                                                                    )[0]
                                                                                }
															-
                                                                                {
                                                                                    el.timetables.openSundayAfternoon.split(
                                                                                        ' '
                                                                                    )[1]
                                                                                }
                                                                            </>
                                                                    }
                                                                </li>
                                                            ) : (
                                                                    <li>
                                                                        {translations.close}
                                                                    </li>
                                                                )}
                                                        </>
                                                    )}
                                            </ul>
                                        </>
                                    )}
                            </div>
                        </div>
                        {type === 'detail' && ((el.subsdiaryType === "FILIALE") || (el.subsdiaryType === "ATMCSA")) && el.services && (
                            <AvailableServices
                                element={el}
                                translations={translations}
                                showServiceInfo={showServiceInfo}
                                setShowServiceInfo={setShowServiceInfo}
                            />
                        )}
                    </>
                }
            </div>
                )}
        </div >
    );
}